<h1 mat-dialog-title>Bevestig verwijderen</h1>
<div mat-dialog-content>
  <p>Weet je zeker dat je <b>{{ data.productionJob.plantName }}</b> wilt verwijderen?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
  <button mat-button color="warn" [mat-dialog-close]="true">Verwijderen</button>
</div>
